/* Collection page: wishlist toggle (localStorage) + skeleton while facets reload.
   Does not read, change or submit any filter state. */
(function () {
  if (window.__colUxInit) return;
  window.__colUxInit = true;
  var KEY = 'theme:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function cardId(btn) {
    var card = btn.closest('.product-card');
    var link = card && card.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0] : null;
  }
  function sync() {
    var list = read();
    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      var id = cardId(btn);
      btn.setAttribute('aria-pressed', id && list.indexOf(id) !== -1 ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = cardId(btn);
    if (!id) return;
    var list = read();
    var i = list.indexOf(id);
    if (i === -1) list.push(id); else list.splice(i, 1);
    write(list);
    btn.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
  });
  document.addEventListener('DOMContentLoaded', sync);
  sync();

  // Skeleton: the theme's facet JS swaps .products-list; flag it while in flight.
  var grid = function () { return document.querySelector('.products-list'); };
  document.addEventListener('click', function (e) {
    if (e.target.closest('.facets form, .facets__form, [class*="facet"] a')) {
      var g = grid(); if (g) g.classList.add('is-loading');
      setTimeout(function () { var x = grid(); if (x) x.classList.remove('is-loading'); }, 1200);
    }
  }, true);
})();
